import React from 'react';
import Proptypes from 'prop-types';
import { ImageCardContainer, ImageCardFooter, ImageContainer } from './index.style';
import Icon from '../../../../atoms/Icon';
import Typography from '../../../../atoms/Typography';

export const PhotoCardCarouselElement = ({
  image,
  onClick,
  onIconClick,
  icon,
  label,
  hasFullView,
}) => (
  <ImageCardContainer onClick={onClick} hasFullView={hasFullView}>
    <ImageContainer image={image} hasFullView={hasFullView} />
    <ImageCardFooter>
      <Typography
        tag="p"
        type={Typography.TYPES.CAPTION}
        style={Typography.STYLES.ALT}
      >
        {label}
      </Typography>
      {icon && (
        <Icon
          onClick={(ev) => {
            onIconClick(ev);
            ev.stopPropagation();
          }}
          icon={icon}
        />
      )}
    </ImageCardFooter>
  </ImageCardContainer>
);

PhotoCardCarouselElement.defaultProps = {
  icon: null,
  onClick: () => null,
  onIconClick: () => null,
  hasFullView: false,
};

PhotoCardCarouselElement.propTypes = {
  image: Proptypes.oneOfType([Proptypes.string, Proptypes.node]).isRequired,
  icon: Proptypes.oneOf(Object.values(Icon.ICONS_TYPE)),
  onClick: Proptypes.func,
  onIconClick: Proptypes.func,
  label: Proptypes.string.isRequired,
  hasFullView: Proptypes.bool,
};

export default PhotoCardCarouselElement;
